import { render } from "./RegisterFacility.vue?vue&type=template&id=19080187&scoped=true"
import script from "./RegisterFacility.vue?vue&type=script&lang=js"
export * from "./RegisterFacility.vue?vue&type=script&lang=js"

import "./RegisterFacility.vue?vue&type=style&index=0&id=19080187&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19080187"]])

export default __exports__